import React, { useContext, useEffect, useRef } from 'react';
import Header from '../../Shared/Headers/Header';
import TopCards from '../../Splitter/Dashboard/TopCards';
import SideMenu from '../../Splitter/SideMenu/SideMenu';
import Activity from '../../Splitter/Dashboard/Activity/Activity';
import Help from '../../User/Dashboard/Help';
import Calendar from '../../Splitter/Dashboard/Calendar';
import State from './State';
import { ClientContext } from '../../Contexts/contexts';
import useAuth from '../../Contexts/useAuth';
import useFetch from '../../Contexts/useFetch';

function DashboardUser() {
  const clientContext = useContext(ClientContext);

  const { checkAuth } = useAuth();
  const { shouldRedirect } = useFetch();
  const ref = useRef(true);

  useEffect(() => {
    if (checkAuth()) {
      const firstRendering = ref.current;

      if (firstRendering) {
        ref.current = false;
        clientContext?.refreshClientExpertRelations();
      } else {
        shouldRedirect();
      }
    }
  }, [clientContext, checkAuth, shouldRedirect]);

  return (
    <>
      <div className="container-header">
        <div>
          <Header />
        </div>
      </div>
      <TopCards />
      <div className="container-dashboard">
        <SideMenu />
        <div className="container-activity-help">
          <div className="container-activity">
            <Activity />
          </div>
          <div className="container-help">
            <Help />
          </div>
        </div>
        <div className="container-calendar-state">
          <div className="container-calendar">
            <Calendar />
          </div>
          <div className="container-state">
            <State />
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardUser;
